const SVG = ({ fill = 'currentColor', width = '11', height = '11', viewBox = '0 0 11 11' }) => (
	<svg width='7' height='13' viewBox='0 0 7 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M0.5 12.5L6.15685 6.84315L0.5 1.18629' stroke='#171717' />
	</svg>
);

export default SVG;
